// extracted by mini-css-extract-plugin
module.exports = {"WelfareCenter":"WelfareCenter_WelfareCenter__FoJXm"};